import { useState } from "react";
import { useParams } from "react-router-dom";
import DataJurnal from "../../components/dataSekolah/Jurnal/DataJurnal";
import JurnalGuruKepsek from "../../components/dataSekolah/Jurnal/JurnalGuruKepsek";
import AbsenGuru from ".././Absen/AbsenGuru";
import KurikulumPdf from "../Kuikulum/KurikulumPdf";
import TarafSerap from "../Tarafserap/TarafSerap";
import ProfileKepsek from "./ProfileKepsek";

const TampilanKepsek = () => {
  const { id } = useParams();
  const [menuAktif, setMenuAktif] = useState("");

  return (
    <div className="max-w-5xl mx-auto px-2">
      {/* JUDUL */}
      <h1 className="text-2xl font-bold mb-6">Tampilan Kepala Sekolah</h1>

      {/* BUTTON */}
      <div className="flex gap-4 mb-6">
        <button
          onClick={() => setMenuAktif("Absen")}
          className={`px-6 py-2 rounded font-semibold transition
            ${
              menuAktif === "Absen"
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
        >
          Absen Murid
        </button>
        <button
          onClick={() => setMenuAktif("Absen guru")}
          className={`px-6 py-2 rounded font-semibold transition
            ${
              menuAktif === "Absen guru"
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
        >
          Absen Guru dan Staff
        </button>
        <button
          onClick={() => setMenuAktif("kurikulum")}
          className={`px-6 py-2 rounded font-semibold transition
            ${
              menuAktif === "kurikulum"
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
        >
          Kurikulum
        </button>
        <button
          onClick={() => setMenuAktif("jurnalguru")}
          className={`px-6 py-2 rounded font-semibold transition
            ${
              menuAktif === "jurnalguru"
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
        >
          Jurnal Guru
        </button>

        <button
          onClick={() => setMenuAktif("tarafSerap")}
          className={`px-6 py-2 rounded font-semibold transition
            ${
              menuAktif === "tarafSerap"
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
        >
          Taraf Serap
        </button>
        <button
          onClick={() => setMenuAktif("jurnal")}
          className={`px-6 py-2 rounded font-semibold transition
            ${
              menuAktif === "jurnal"
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
        >
          Jurnal Kepala Sekolah
        </button>
      </div>

      {/* KONTEN */}
      <div className="bg-white border rounded p-4">
        {menuAktif === "Absen" && <ProfileKepsek />}
        {menuAktif === "Absen guru" && <AbsenGuru />}

        {menuAktif === "jurnal" && <DataJurnal id={id} />}
        {menuAktif === "tarafSerap" && <TarafSerap />}
        {menuAktif === "kurikulum" && <KurikulumPdf />}
        {menuAktif === "jurnalguru" && <JurnalGuruKepsek />}

        {!menuAktif && (
          <p className="text-gray-400">Silakan pilih menu terlebih dahulu</p>
        )}
      </div>
    </div>
  );
};

export default TampilanKepsek;
